import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { closeScreenShotGallery, setClientScreenshot, setMomentGA } from '../../store/app/index';
import './screenshot-list.css';
import { isMobile } from 'react-device-detect';
import { PREVIEW_AUTO_HIDE_TIME, MAX_UPLOADED_FILE_SIZE } from '../../constants';
import * as Utils from '../../utils';
const SCREENSHOT_EVENTS = {
  LIGHTBOX_CLOSED: 'LIGHTBOX_CLOSED',
  DBSS_PRESENT: 'DBSS_PRESENT ',
  MOMENT_EVENT: 'MOMENT_EVENT',
};

const ScreenshotList = ({
  screenshotList,
  clientScreenshots,
  eventId,
  ssPreview,
  closeScreenShotGallery,
  setClientScreenshot,
  DRMode,
  momentsAllowed,
  showMoments,
  setCrop,
  mLEnable,
  webview,
  eventTitle,
  momentsAllowedJson,
  layersJson,
  setMomentGA,
  previewAutoHideTime,
  maxUploadedFileSize,
  openScreenShotGallery,
  layers,
}) => {
  const ssRef = React.useRef(null);
  const galleryRef = React.useRef(null);
  useEffect(() => {
    const screenshotGalleryEl = document.getElementById('screenshots-gallery');
    if (
      (Utils.hasNotValue(showMoments) || showMoments) &&
      ((screenshotList && screenshotList.length !== 0) || clientScreenshots)
    ) {
      if (screenshotGalleryEl) {
        screenshotGalleryEl.style.display = 'block';
      }
    } else {
      if (screenshotGalleryEl) {
        screenshotGalleryEl.style.display = 'none';
      }
    }
  }, [showMoments, screenshotList, clientScreenshots]);
  const onPhotoShare = (moment) => {
    Utils.callWebviewController('photoShare', {
      image: moment.screenshot,
      eventTitle,
    });
  };
  const onDownloadClick = (moment) => {
    Utils.callWebviewController('savePhoto', {
      image: moment.screenshot,
      name: String(moment.timestamp),
    });
  };

  const loadScreenshotHistory = () => {
    if (screenshotList && screenshotList.length) {
      for (let index = 0; index < screenshotList.length; index++) {
        let screenShotObj = {
          screenshot: screenshotList[index].url,
          timestamp: screenshotList[index].ct,
          admin: true,
          id: screenshotList[index].id,
          thumbnail: screenshotList[index].thumbUrl,
          raw: screenshotList[index].rawUrl,
        };
        ssRef.current && ssRef.current.addScreenshot(screenShotObj);
      }
    }
  };

  useEffect(() => {
    var layersObj = Object.assign({}, layersJson, layers);
    ssRef.current = new window.CleoMoments({
      ui: {
        container: galleryRef.current,
      },
      eventId: eventId,
      admin: false,
      isMobile: isMobile,
      dbSSCount: true,
      momentsAllowed: momentsAllowedJson,
      previewAutoHideTime: previewAutoHideTime ? previewAutoHideTime : PREVIEW_AUTO_HIDE_TIME,
      layers: Object.keys(layersObj).length !== 0 ? layersObj : null,
      mLEnable: mLEnable,
      previewEl: document.getElementById('preview'),
      photoShare: Boolean(webview),
      onPhotoShare,
      onDownloadClick: webview ? onDownloadClick : null,
      maxUploadedFileSize: maxUploadedFileSize ? maxUploadedFileSize : MAX_UPLOADED_FILE_SIZE,
      momentsListViewType: 'CAROUSEL',
    });
    ssRef.current.on(SCREENSHOT_EVENTS.DBSS_PRESENT, function () {
      setClientScreenshot();
    });
    ssRef.current.on(SCREENSHOT_EVENTS.LIGHTBOX_CLOSED, function () {
      closeScreenShotGallery();
    });

    ssRef.current.on(SCREENSHOT_EVENTS.MOMENT_EVENT, function (data) {
      setMomentGA(data);
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!DRMode) {
      loadScreenshotHistory();
    }
    //eslint-disable-next-line
  }, [screenshotList]);

  useEffect(() => {
    if (ssPreview) {
      ssRef.current && ssRef.current.viewInGallery();
    }
  }, [ssPreview]);

  return <>{<div className="screenshots-gallery" id="screenshots-gallery" ref={galleryRef}></div>}</>;
};

const mapStateToProps = (state) => ({
  screenshotList: state.app.screenshotList,
  clientScreenshots: state.app.clientScreenshots,
  eventId: state.app.eventId,
  ssPreview: state.app.ssPreview,
  DRMode: state.app.DRMode,
  momentsAllowed: state.app.momentsAllowed,
  momentsAllowedJson: state.app.apiKeyJson?.conf?.modules?.moments?.mode,
  showMoments: state.app.apiKeyJson.conf?.endScreen?.showMoments,
  layers: state.app.layers,
  mLEnable: state.app.mLEnable,
  webview: state.app.config.webview,
  eventTitle: state.app.welcomeData?.meta?.title,
  layersJson: state.app.apiKeyJson?.conf?.modules?.moments?.composition,
  previewAutoHideTime: state.app.apiKeyJson?.conf.modules?.moments?.previewAutoHideTime,
  maxUploadedFileSize: state.app.apiKeyJson?.conf.modules?.moments?.maxUploadedFileSize,
});

const mapDispatchToProps = {
  closeScreenShotGallery,
  setClientScreenshot,
  setMomentGA,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreenshotList);
